import { CrudState } from "@/store/modules/crud/State";
import IWineType from "@/models/IWineType";

export class State extends CrudState {
  dataList: Array<IWineType> = [];
  dataItem: IWineType | null = null;
}
